import { useSeo } from '@/lib/seo';

export default function AffiliateDisclosurePage() {
  useSeo({
    title: 'Affiliate Disclosure | A Guy Who Hunts',
    description:
      'How A Guy Who Hunts handles affiliate links and product recommendations — clearly disclosed, never required for coverage.',
  });
  return (
    <div className="mx-auto max-w-[72ch] px-4 sm:px-6 lg:px-8 py-16 prose-editorial">
      <p className="kicker">Affiliate disclosure</p>
      <h1 className="font-serif text-4xl tracking-tight mt-2">How affiliate links work here.</h1>
      <p>
        Some links on this site — particularly on the Gear page, in Field Notes about equipment, and occasionally in
        newsletter emails — may be affiliate links. That means if you click through and make a purchase, this site may
        receive a small commission at no additional cost to you.
      </p>
      <h2>What this changes</h2>
      <ul>
        <li>Nothing about which products get covered. A brand cannot pay to be recommended.</li>
        <li>Nothing about the honesty of a review. If a piece of gear was disappointing, that will be said.</li>
        <li>Commissions help offset the cost of cameras, cards, gas, tags, and time spent making the videos.</li>
      </ul>
      <h2>How to spot an affiliate link</h2>
      <p>
        When a link is affiliate, it will be clearly marked on the page and on the destination site’s domain. If you
        prefer not to use affiliate links, you can always search the product name directly from your browser.
      </p>
      <p className="text-[hsl(var(--muted-foreground))]">
        Questions? Get in touch through the contact page.
      </p>
    </div>
  );
}
